/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Attachment } from './Attachment';
import {
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    AttachmentToJSONTyped,
} from './Attachment';

/**
 * Represents an inbox item, the canonical DTO for the resource.
 * @export
 * @interface InboxItem
 */
export interface InboxItem {
    /**
     * 
     * @type {string}
     * @memberof InboxItem
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof InboxItem
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InboxItem
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof InboxItem
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof InboxItem
     */
    text?: string;
    /**
     * 
     * @type {Attachment}
     * @memberof InboxItem
     */
    attachment?: Attachment;
}

/**
 * Check if a given object implements the InboxItem interface.
 */
export function instanceOfInboxItem(value: object): value is InboxItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InboxItemFromJSON(json: any): InboxItem {
    return InboxItemFromJSONTyped(json, false);
}

export function InboxItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'source': json['source'] == null ? undefined : json['source'],
        'text': json['text'] == null ? undefined : json['text'],
        'attachment': json['attachment'] == null ? undefined : AttachmentFromJSON(json['attachment']),
    };
}

export function InboxItemToJSON(json: any): InboxItem {
    return InboxItemToJSONTyped(json, false);
}

export function InboxItemToJSONTyped(value?: InboxItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'source': value['source'],
        'text': value['text'],
        'attachment': AttachmentToJSON(value['attachment']),
    };
}

